import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IItem } from "src/domain/entities"
import { ItemListView } from "."

interface Props {
	list: IItem[]
	isLoading: boolean
	onUpdate: (item: IItem) => void
	onDelete: (item: IItem) => void
	onAddClick: () => void
}

export const ItemListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No items found." onAddClick={onAddClick} />
	}

	return <ItemListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
